<template>
  <router-view />
</template>

<script>
export default {
  name: 'UmsUsersWrapper',
};
</script>
